"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "course_zlb": {
    "allCourses": "全部课程",
    "className": "研讨名称",
    "continue": "继续学习",
    "courseChapter": "章节",
    "courseEvaluate": "课程评价",
    "courseHours": "学时",
    "courseInfo": "详情",
    "courseNote": "笔记",
    "coursesCategory": "课程分类",
    "electiveCourses": "选修课程",
    "pages": "页",
    "relatedCourses": "相关课程",
    "requiredCourses": "讲座",
    "searchTips": "请输入课程名称",
    "studentsNum": "观看人数",
    "teachersDesc": "讲师简介",
    "newCourse": "最新课程"
  },
  "footer_zlb": {
    "aboutUs": "关于我们",
    "downLoad": "APP下载",
    "qr": "二维码"
  },
  "global_zlb": {
    "am": "上午",
    "isa": "个",
    "night": "晚上",
    "pm": "下午"
  },
  "header_zlb": {
    "accoutPw": "账户密码",
    "curDis": "当前研讨",
    "curUser": "当前用户",
    "edit": "修改",
    "helpCenter": "帮助中心",
    "hisDis": "历史研讨",
    "index": "首页",
    "joinStore": "加入收藏夹",
    "logo": require('@/static/images/index_zlb/logo.png'),
    "logoText": require('@/static/images/index_zlb/logo-t.png'),
    "message": "消息",
    "setIndex": "设为首页",
    "userImg": "用户头像"
  },
  "index_zlb": {
    "discuss": "研讨",
    "find": "发现",
    "textImg": require('@/static/images/index_zlb/text.png'),
    "userCenter": "个人中心"
  },
  "info_zlb": {
    "admin": "管理员",
    "hasAgenda": "已经参加过该日程！",
    "noDown": "暂无附件可下载！",
    "pleaseInp": "请输入",
    "submit": "提交成功！",
    "withinTime": "任务未开始",
    "noSubmitWork": "您未提交作业"
  },
  "login_zlb": {
    "accountLogin": "账号登录",
    "accountNotEmpty": "账号不能为空",
    "bg": require('@/static/images/login_zlb/login_bg.jpg'),
    "bian": require('@/static/images/login_zlb/bianzu.png'),
    "cancel": "取消",
    "captchaNotEmpty": "验证码不能为空",
    "captchaTips": "验证码输入错误",
    "changeEmail": "修改邮箱",
    "changeEmailSuccess": "修改邮箱成功",
    "changeEmailSuccessTips": "您已修改邮箱成功",
    "Confirm": "确定",
    "currentEmail": "当前邮箱",
    "emailCaptcha": "邮箱验证码",
    "emailCaptchaEmpty": "邮箱验证码不能为空",
    "encryEmail": "密保邮箱",
    "error": "验证码错误",
    "forget": "忘记密码",
    "formerEamil": "原邮箱",
    "incorrectTips": "用户名或密码输入错误",
    "logo": require('@/static/images/login_zlb/logo.png'),
    "newEmail": "新邮箱",
    "newEmailBinded": "新邮箱已绑定",
    "newEmailEmpty": "新邮箱不能为空",
    "newEmailFomat": "新邮箱格式不正确",
    "newEmailSupport": "新邮箱不能与原邮箱一致",
    "prevStep": "上一步",
    "nextStep": "下一步",
    "reset": "重置",
    "loginNow": "立即登录",
    "resetSuccess": "重置成功",
    "resetSuccessTips": "您已重置密码成功，请前往登录",
    "msgCaptcha": "短信验证码",
    "getCaptcha": "获取验证码",
    "resetPassword": "重置密码",
    "loginFail": "登录失败，请重试!",
    "failTips": "校验失败",
    "inputUserName": "请输入用户名",
    "goHome": "前往首页",
    "passwordFormat": "密码长度8到32位，包含数字和大小写字母",
    "surePasswordEmpty": "确认密码不能为空",
    "confirmNot": "所填密码和确认密码不一致",
    "changePasswordSuccess": "修改密码成功",
    "continueLogin": "重新登录",
    "orError": "账号或密码错误",
    "orgEmailEmpty": "原邮箱不能为空",
    "orgEmailFormat": "原邮箱格式不正确",
    "orgEmailNot": "原邮箱不正确",
    "passWord": "请输入密码",
    "surePassword": "请确认密码",
    "passwordBits": "密码长度不能小于6位",
    "passwordNotEmpty": "密码不能为空",
    "pWord": "密码",
    "sign": "登录",
    "uName": "账号",
    "userName": "请输入用户名",
    "validate": "请输入验证码",
    "verification": "请完成下方验证",
    "appdownload": "移动端下载",
    "scancode": "扫描二维码下载",
    "poor": "弱",
    "middle": "中",
    "strong": "强"
  },
  "login": {
    "logout": "登出成功",
    "resetLoginTips": "您已修改密码成功，需要重新登录，3秒后自动退出",
    "sure": "确定",
    "cancel": "取消",
    "captchaNotEmpty": "验证码不能为空",
    "accountNotEmpty": "账号不能为空",
    "passwordNotEmpty": "密码不能为空",
    "inputCaptcha": "请输入验证码",
    "getCaptcha": "获取验证码",
    "inputOrigPassword": "请输入原密码",
    "inputNewPassowrd": "请输入新密码",
    "confimPassword": "请确认密码",
    "changePassword": "修改密码",
    "nextStep": "下一步",
    "resetPassword": "重置密码",
    "resetDone": "重置完成",
    "msgCaptcha": "邮箱验证码"
  },
  "look_zlb": {
    "aboutLecturer": "相关课程",
    "benginLearn": "开始学习",
    "chapter": "章节",
    "delete": "删除",
    "details": "详情",
    "download": "下载",
    "dynamic": "动态",
    "evaluation": "评价",
    "hotDyc": "热门动态",
    "lecture": "公开课",
    "lecturer": "讲师",
    "lectureTest": "课程分类",
    "look": "发现",
    "lookAll": "查看全部",
    "note": "笔记",
    "score": "评分"
  },
  "myMessage_zlb": {
    "passwordError": "原始密码输入错误",
    "aboutUs": "关于我们",
    "allcourse": "全部课程",
    "atypism": "两次密码不一致",
    "birth": "出生日期",
    "cancel": "取消",
    "carryOut": "完成",
    "changePassword": "修改密码",
    "chineseName": "中文姓名",
    "chineseNamePlaceholder": "请输入中文姓名",
    "code": "验证码",
    "codeError": "验证码错误",
    "comment": "评论",
    "complete": "完成",
    "completeUserInfo": "请完善个人信息",
    "confirm": "确认密码",
    "continueStudy": "继续学习",
    "country": "国家",
    "countryName": "外文姓名",
    "countryNamePlaceholder": "请输入本国姓名",
    "countryPlaceholder": "请选择国家",
    "courseLearned": "已学习",
    "delete": "删除",
    "documentType": "证件类型",
    "downloaded": "已下载",
    "downloading": "下载中",
    "eduLevel": "教育水平",
    "eduLevelPlaceholder": "请选择教育水平",
    "email": "邮箱",
    "emailCode": "邮箱验证码",
    "gender": "性别",
    "genderPlaceholder": "请选择性别",
    "getCode": "获取邮箱验证码",
    "hasSent": "已发送",
    "helpCenter": "帮助中心",
    "hour": "小时",
    "improveInformation": "请完善您的个人信息",
    "joinClasses": "共参与课程",
    "joinDis": "共参与研讨",
    "learned": "已学完",
    "learning": "学习中",
    "lecture": "课程",
    "mailbox": "邮箱",
    "mailboxValidate": "邮箱验证失败",
    "man": "男",
    "management": "管理",
    "minutes": "x小时x分",
    "modify": "修改",
    "modifyEmail": "修改邮箱",
    "my": "我自己",
    "myCertificate": "我的证书",
    "mycourse": "我的课程",
    "myDownload": "我的下载",
    "myLecture": "我的课程",
    "myNotes": "我的笔记",
    "newMail": "新邮箱",
    "newPassword": "新密码",
    "nextStep": "下一步",
    "orError": "账号或密码错误",
    "origin": "源自",
    "originalPassword": "原始密码",
    "password": "密码",
    "phone": "手机号",
    "pleChoose": "请选择出生日期",
    "post": "职务",
    "postPlaceholder": "请输入职务",
    "religion": "宗教",
    "religionPlaceholder": "请选择宗教",
    "retrievePassword": "找回密码",
    "setUp": "设置",
    "signOut": "退出登录",
    "something": "准备说点什么",
    "submit": "提交",
    "sureDelte": "你确定删除此条数据吗？",
    "teacher": "教师",
    "learnYet": "尚未开始学习",
    "uName": "用户名",
    "uNamePlaceholder": "请输入用户名",
    "userCenter": "个人信息",
    "username": "用户名",
    "validateMsg": "校验失败",
    "woman": "女",
    "learnTo": "学习至",
    "myRecord": "自己的记录",
    "plePhone": "请输入手机号"
  },
  "notice_zlb": {
    "delete": "删除",
    "home": "首页",
    "lettre": "私信",
    "lettreEmpty": "私信内容不能为空",
    "messageDetail": "消息详情",
    "myMessage": "我的消息",
    "notice": "通知公告",
    "nowBavarder": "现在可以开始聊天了",
    "send": "发 送"
  },
  "play_zlb": {
    "networkTip": "网络提醒",
    "streamHighTip": "当前网络情网络较好，已为您切换到高清",
    "streamHighType": "高清",
    "streamNormTip": "当前网络情况不佳，已为您切换到标清",
    "streamNormType": "标清",
    "liveTimeDes": "直播时间",
    "livePlayWait": "直播未开始",
    "livePlayEnd": "直播已结束"
  },
  "questionnaire_zlb": {
    "handed": "提交",
    "saveFailed": "保存失败",
    "examList": "试题列表"
  },
  "research_zlb": {
    "afternoon": "下午",
    "all": "全部",
    "allCalendar": "全部日程",
    "alumniBook": "成员",
    "broadcast": "x开播",
    "carriedout": "已进行",
    "certificate": "证书",
    "comment": "评论",
    "comments": "全部x条评论",
    "courses": "参阅",
    "curDis": "当前研讨",
    "default": "未开始",
    "delete": "删除",
    "detail": "详情",
    "discuss": "讨论",
    "end": "已结束",
    "endAssess": "评估结束",
    "enterAssess": "进入评估",
    "assessButton": "研讨评估",
    "evaluation": "评估",
    "fileAcept": "文件类型错误，请重新上传",
    "fileSize10": "所选文件超过10M，请重新上传",
    "hisDis": "历史研讨",
    "lecture": "参阅",
    "live": "直播中",
    "livebroadcast": "直播",
    "minutes": "x分钟前",
    "month": "月",
    "morning": "上午",
    "noDiscussion": "暂无研讨",
    "noSchedule": "暂无日程",
    "notice": "通知",
    "notification": "未读通知",
    "offline": "面授",
    "onging": "进行中",
    "online": "线上",
    "operation": "作业",
    "over": "已结束",
    "participated": "已参与",
    "notParticipate": "未参与",
    "failedCourse": "未通过",
    "passedCourse": "已通过",
    "preparation": "准备任务（截止）",
    "preparations": "准备任务",
    "preschoolLecture": "学前讲座",
    "questionnaire": "问卷",
    "questionType ": "题型（单选题、多选题、判断题、简答题）",
    "readySay": "准备说点什么",
    "replies": "您有x条新回复",
    "save": "保存",
    "schedule": "日程",
    "searchC": "搜索你感兴趣的内容",
    "seeAssess": "查看评估",
    "submit": "提交",
    "submitHomewor": "取消",
    "task": "任务",
    "taskToday": "今日任务",
    "video": "视频",
    "week": "星期",
    "yourcomment": "写下你的评论...",
    "legend": "图例",
    "sunday": "周日",
    "monday": "周一",
    "tuesday": "周二",
    "wednesday": "周三",
    "thursday": "周四",
    "friday": "周五",
    "saturday": "周六",
    "consult": "参阅数量",
    "schedules": "日程数量",
    "calendar": "日历概览",
    "waitAssesment": "待提交的问卷",
    "year": "年",
    "day": "日",
    "preview": "预览",
    "resource": "下载"
  },
  "retrieve_zlb": {
    "emailEmpty": "邮箱不能为空",
    "emailVerif": "邮箱验证"
  },
  "task_zlb": {
    "downF": "下载附件",
    "repeatUp": "重新上传",
    "ruY": "如APP端已上传附件，PC端再次上传会将已有附件进行覆盖。",
    "submitC": "请输入您要提交的内容",
    "uploadF": "上传附件"
  },
  "upload_zlb": {
    "clickHere": "点击这里",
    "limit": "文件格式支持PNG、JPG大小不能超过",
    "preview": "上传图片后可预览",
    "upload": "上传"
  },
  "index": {
    "setAsHomePage": "设为首页",
    "addCollection": "加入收藏夹",
    "telephone": "咨询电话",
    "Help": "帮助中心",
    "SystemMessage": "系统提醒",
    "message": "私信",
    "emptyMessage": "清空",
    "checkAllMessage": "查看全部",
    "noMessage": "暂无数据",
    "fullScreen": "全屏展示",
    "ExitSystem": "退出此系统",
    "back": "返回",
    "top": "顶部",
    "backToTop": "返回顶部",
    "homePage": "首页",
    "favoriteTips": "由于360浏览器功能限制，请按 Ctrl+D 手动收藏！",
    "autoSetHomeTips": "您的浏览器不支持自动自动设置首页, 请使用浏览器菜单手动设置!",
    "currentUser": "当前用户",
    "userHead": "用户头像",
    "accountPassword": "账户密码",
    "change": "修改",
    "head": "头像",
    "continueStudy": "继续学习",
    "startStudy": "开始学习"
  },
  "course": {
    "count": "共",
    "item": "条",
    "up": "上一页",
    "next": "下一页",
    "items": "条/页",
    "go": "跳至",
    "page": "页",
    "man": "人",
    "score": "分",
    "courseYear": "年",
    "courseTeachers": "教师",
    "noDesc": "暂无简介",
    "teachersDesc": "教师简介",
    "checkLog": "查看记录",
    "startStudy": "开始学习",
    "JoinLearning": "加入学习",
    "isEvaluate": "已评价",
    "deleteNoteButton": "删除",
    "closeButton": "关闭",
    "noteSource": "源自"
  },
  "onlineclass": {
    "myScore": "我的得分",
    "comments": "评语",
    "iknow": "我知道了",
    "detail": "详情",
    "inforCertificate": "证书",
    "wantTalk": "我要讨论",
    "inputTalkContent": "请输入讨论内容",
    "publish": "发布",
    "undo": "取消",
    "reply": "回复",
    "delete": "删除",
    "Learned": "已学习",
    "isDelete": "您确定要删除吗？",
    "submitTime": "提交时间",
    "to": "至",
    "download": "下载"
  },
  "usercenter": {
    "htllo": "您好",
    "welcomeMessage": "祝您开心每一天",
    "searchTips": "输入搜索的课程名称",
    "myCertificate": "我的证书",
    "startQuestionnaire": "开始答卷",
    "empty": "无",
    "confirmDelete": "删除确认",
    "confirmDeleteTips": "是否确认删除",
    "delete": "删除",
    "integralscore": "学员积分"
  },
  "play": {
    "endStudy": "结束学习",
    "tips": "温馨提示",
    "playTips": "温馨提示：为保证您的学习时间被系统正常记录，请您点击右上角的“结束学习”按钮退出学习，如果直接关闭浏览器您的学习时间可能无法正常记录。",
    "notShowAgain": "不再提示此信息",
    "gotIt": "我知道了",
    "chapter": "章节",
    "language": "语言",
    "chapterText1": "第",
    "chapterText2": "章",
    "note": "笔记",
    "noteBlockTitle": "笔记",
    "evaluate": "评价",
    "evaluateStar": "星",
    "saveEvaluate": "提交",
    "notePlaceholder": "请输入笔记",
    "closeTips": "系统可能不会保存您所做的更改",
    "closeButton": "离开",
    "autoStop": "自动停止播放",
    "autoStopTips": "由于你长时间未有操作，系统自动停止了视频播放",
    "confirmOut": "您确定退出播放吗？",
    "closeOrNot": "是否关闭当前窗口",
    "noCoursePlay": "当前课程中无可播放课件",
    "attention": "请注意！"
  },
  "assessment_zlb": {
    "score": "分",
    "evalSuccess": "评估成功"
  },
  "undefined": {
    "undefined": "El contenido de la nota no puede estar en blanco"
  }
};